module.exports = __webpack_public_path__ + "img/ranking.cf2b71f3.png";